/**
 * @desc 列表
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<ObjectMap>;
export function request(
  params: API.appCenter.bizPermissionApplyRoles.list.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/bizPermissionApplyRoles/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
